<template>
    <div v-loading="loading"
         style="margin-top: 5%;">
        <el-upload class="upload-demo"
                   ref="upload"
                   :action="uploadUrl"
                   :on-preview="handlePreview"
                   :on-remove="handleRemove"
                   :file-list="fileList"
                   :auto-upload="false"
                   multiple
                   :before-upload="handleBefore"
                   :headers="headers"
                   accept=".xlsx,.xls"
                   :on-success="success"
                   :on-error="error"
                   :on-change="change">
            <template #trigger>
                <el-button size="small" type="primary">选取{{$route.query.year}}年{{openType}}公开表</el-button>
            </template>
            <el-button style="margin-left: 10px;" @click="submitUpload" size="small" type="success">开始导入</el-button>         
        </el-upload>
    </div>
</template>
<script>
    import { getDivList } from '@/api/index.js'
    import url from "@/api/config.js";
    import { importTable } from '@/api/gk.js'
    export default {
        name: 'importView',
        data() {
            return {
                fileList: [],
                newfileList: [],
                headers: {
                    session: window.$cookies.get("session"),
                    zone: window.$cookies.get("zone"),
                },
                uploadUrl: "",
                wjmname: '',
                divid:'',
                type: this.$store.state.openType,
                formData: Object,
                loading: false,
                openType:this.$store.state.openType == 'js' ? '决算' : '预算'
            }
        },
        created() {
            this.divid = this.$route.query.divid;
            if(localStorage.getItem('ipUrl')){
                let ipUrl = localStorage.getItem('ipUrl')
                this.uploadUrl = `${ipUrl}/div/import`;
            }else{
                this.uploadUrl = `${url.baseUrl.dev}div/import`;
            }
        },
        methods: {
            async getDivList() {
                let res = await getDivList({ id: this.divid })
                if (res.status == 0) {
                    this.$store.commit('changeDivData', res)
                    //获取表数据
                    this.$store.commit("changeTableData", res.tables.filter(item => item.year == this.$store.state.openYear && item.type == this.type))
                }
            },
            //导入
            async submitUpload() {
                this.loading = true;
                let res = await importTable(this.formData)
                if(res.status==0){
                    this.$message.success("导入成功")
                    await this.getDivList()
                }
                this.loading = false;
            },
            //文件改变触发的事件
            change(file) {       
                let formData = new FormData();
                formData.append("file", file.raw)
                formData.append("id", this.divid)
                formData.append("year", this.$route.query.year)
                formData.append("type", this.type)
                this.formData = formData;
            },
            handleBefore(file) {
                this.loading = true;
                const isExcel1 =
                    file.type ===
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                const isExcel2 = file.type === "application/vnd.ms-excel";
                if (!isExcel1 && !isExcel2) {
                    this.$message.error("上传文件只能是excel!");
                    return isExcel1 && isExcel2;
                }
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(
                    `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
                    } 个文件`
                );
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
        },
    }
</script>